<script lang="ts" setup>
import { onMounted, onBeforeUnmount, ref } from 'vue';
import { normalObserve, normalUnobserve } from '@/observer';

// 定义组件变体类型, 格式: 页面类型-组件类型
const props = defineProps<{
    variant:
        | 'card-card_rec'
        | 'card-list_rec'
        | 'std-card_rec'
        | 'std-list_rec'
        | 'std-swipe_rec';
}>();

const emit = defineEmits<{
    loadMore: [];
}>();

const loadMoreRef = ref<HTMLDivElement | null>(null);

onMounted(() => {
    if (!loadMoreRef.value) return;

    // 设置视口监听回调
    const callbacks = {
        onExposure: () => {
            emit('loadMore');
        },
    };

    // 开始监听元素进入视口
    normalObserve(loadMoreRef.value, callbacks);
});

onBeforeUnmount(() => {
    if (!loadMoreRef.value) return;
    // 清理视口监听
    normalUnobserve(loadMoreRef.value);
});
</script>

<template>
    <!-- 加载更多触发器, 根据变体应用不同样式 -->
    <div
        ref="loadMoreRef"
        class="load_more"
        :data-variant="props.variant"
    ></div>
</template>

<style lang="scss" scoped>
@use './LoadMore.scss';
</style>
